module.exports = "//static.hsappstatic.net/codemirror/static-5.71/codemirror.css"